/**
 * Debounce a function so it only executes after a wait period has elapsed since the last call.
 * @param {Function} fn - The function to debounce.
 * @param {number} wait - The number of milliseconds to wait after the last call.
 * @returns {Function} - The debounced function.
 */
export function debounce(fn, wait) {
  let timeout
  return function (...args) {
    const context = this
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      fn.apply(context, args)
    }, wait)
  }
}
